module.exports = __webpack_public_path__ + "static/media/selected_star.5ce1818e.svg";